import React, { useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';
import { useShellHeader } from '@/context/ShellHeaderContext';
import { cn } from '@/lib/utils';

export function AppPage({ children, className, width = 'wide' }) {
  return (
    <div className={cn('app-page', `app-page--${width}`, className)}>
      {children}
    </div>
  );
}

export function AppPageHeader({
  eyebrow,
  title,
  actions,
}) {
  const { actionSlot, clearHeaderMeta, setHeaderMeta } = useShellHeader() || {};

  useLayoutEffect(() => {
    if (!setHeaderMeta) return undefined;
    setHeaderMeta({ eyebrow, title });
    return () => clearHeaderMeta?.();
  }, [clearHeaderMeta, eyebrow, setHeaderMeta, title]);

  if (!actions || !actionSlot) return null;
  return createPortal(actions, actionSlot);
}

export function AppSectionHeader({ eyebrow, title, description, actions, className }) {
  return (
    <div className={cn('app-section-header', className)}>
      <div className="app-section-header__copy">
        {eyebrow ? <span className="app-section-header__eyebrow">{eyebrow}</span> : null}
        <h2 className="app-section-header__title">{title}</h2>
        {description ? <p className="app-section-header__description">{description}</p> : null}
      </div>

      {actions ? <div className="app-section-header__actions">{actions}</div> : null}
    </div>
  );
}

export function AppMetricCard({
  icon: Icon,
  label,
  value,
  note,
  accent = 'var(--accent-primary)',
  className,
}) {
  return (
    <div className={cn('app-metric-card', className)} style={{ '--metric-accent': accent }}>
      {Icon ? (
        <span className="app-metric-card__icon">
          <Icon size={18} />
        </span>
      ) : null}
      <p className="app-metric-card__value">{value}</p>
      <p className="app-metric-card__label">{label}</p>
      {note ? <p className="app-metric-card__note">{note}</p> : null}
    </div>
  );
}

export function AppEmptyState({ icon: Icon, title, description, action, className }) {
  return (
    <div className={cn('app-empty-state', className)}>
      {Icon ? (
        <span className="app-empty-state__icon">
          <Icon size={22} />
        </span>
      ) : null}
      <div className="app-empty-state__copy">
        <h3 className="app-empty-state__title">{title}</h3>
        {description ? <p className="app-empty-state__description">{description}</p> : null}
      </div>
      {action ? <div className="app-empty-state__action">{action}</div> : null}
    </div>
  );
}
